<dt-modal-content
  (closeClick)="closeModal()"
  [contentPadding]="false"
  [flexContent]="true"
  [showFooter]="state === 'saving' || state === 'idle'"
>
  <ng-template #title i18n>Speichern unter…</ng-template>
  <ng-template #content>
    @switch (state) {
      @case ('loading') {
        <mat-spinner></mat-spinner>
      }
      @case ('load-error') {
        <div class="error-container">
          <mat-icon color="warn">error</mat-icon>
          <div i18n>Beim Laden der Projekte aus Deinem Account ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.</div>
        </div>
      }
      @default {
        <dt-project-list
          [(projects)]="projects"
          [(projectFolders)]="projectFolders"
          [shouldLoadProjects]="false"
          [(currentFolderId)]="currentFolderId"
          [(highlightedProjectName)]="newProjectForm.controls.name.value"
          (loadedProject)="clickedProject($event)"
        >
        </dt-project-list>
        <mat-divider></mat-divider>
        <form class="dt-form new-project-form" [formGroup]="newProjectForm" (ngSubmit)="saveAs()">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label i18n>Projektname</mat-label>
            <input dtAutoFocus matInput formControlName="name" data-cy="project-name-input" />
          </mat-form-field>
        </form>
      }
    }
  </ng-template>
  <ng-template #footer>
    <button
      mat-raised-button
      color="accent"
      [disabled]="state === 'saving' || newProjectForm.invalid"
      [dtOverlayProgress]="state === 'saving'"
      #saveButton
      (click)="saveAs()"
      data-cy="save-as-confirm-button"
      ><mat-icon>save</mat-icon><ng-container i18n>Speichern</ng-container></button
    >
    <button mat-raised-button color="accent-less" (click)="closeModal()" i18n>Abbrechen</button>
  </ng-template>
</dt-modal-content>
